import React, {
    useState
} from "react";

import {
    Card,
    Row,
    Col,
    Tag,
    Divider,
    Button,
    Descriptions,
    Avatar,
    Space,
    Typography, message
} from "antd";

import {
    ShopOutlined,
    PhoneOutlined,
    EnvironmentOutlined,
    UserOutlined,
    MailOutlined,
    HeartOutlined,
    FileTextOutlined
} from "@ant-design/icons";
// import {marketplaceApi} from "../../servics/marketplace/marketpleApi";
import {useParams} from "react-router-dom";
// import ProductInquiry from "./ProductInquiry";
import DeliveryEstimation from "./DeliveryEstimation";
import {useDispatch, useSelector} from "react-redux";
import {addProductToWishlist} from "../../hooks/addProductToWishlist";
import getProductImage, { fallbackToDefaultImage } from "../../utils/getProductImage";
import useCurrency from "../../hooks/useCurrency";
import {createInquiry} from "../../servics/marketplace/marketplaceApi";
import BuyerMarketplaceConversationDrawer from "../conversation/BuyerMarketplaceConversationDrawer";

const { Title, Text } = Typography;

const ProductInstanceDetails = () => {

    const { subCategoryId, productInstanceId } = useParams();

    const countryCode = useSelector(
        state => state.country.country.value
    );

    const { currency } = useCurrency();

    const [inquiryId, setInquiryId] =
        useState(null);

    const marketplaceProducts =
        useSelector(
            state => state.marketplace.products
        );

    const product =
        marketplaceProducts.find(

            p => p.id === productInstanceId
        );

    const dispatch = useDispatch();

    const user = useSelector((state) => state.auth.user);
    const tenantUser = useSelector((state) => state.tenantUser.tenantUser);
    const tenant = useSelector((state) => state.tenant.company);

    const [inquiryOpen, setInquiryOpen] =
        useState(false);

    const [deliveryOpen, setDeliveryOpen] =
        useState(false);

    const [wishlistLoading, setWishlistLoading] =
        useState(false);

    if (!product) {

        return (
            <Card>
                Produit introuvable
            </Card>
        );
    }

    const imageSource = getProductImage(product.productName, product.subCategoryName, product.categoryName);

    const handleAddToWishlist =
        async () => {

            try {

                setWishlistLoading(true);

                await dispatch(

                    addProductToWishlist({

                        buyerId:
                        tenantUser.tenantUserId,

                        productInstanceId:
                        product.productInstanceId

                    })

                ).unwrap();

                message.success(
                    "Produit ajouté aux favoris"
                );

            } catch (error) {

                message.error(
                    "Impossible d'ajouter aux favoris"
                );

            } finally {

                setWishlistLoading(false);
            }
        };

    const handleOpenConversation =
        async () => {

            try {
                console.log(
                    "auth.user",
                    user
                );

                console.log(
                    "tenantUser",
                    tenantUser
                );

                console.log(
                    "tenant",
                    tenant
                );

                const inquiry =
                    await createInquiry(

                        {
                            productInstanceId,

                            buyerId:
                            user.tenant_id

                        },

                        countryCode
                    );

                setInquiryId(
                    inquiry.inquiryId
                );

                setInquiryOpen(true);

            } catch (error) {

                console.error(
                    "OPEN CONVERSATION ERROR",
                    error
                );

                message.error(
                    "Impossible d'ouvrir la conversation"
                );
            }
        };

    return (

        <div
            style={{
                maxWidth: 1400,
                margin: "0 auto",
                padding: 24
            }}
        >

            <Card
                bordered={false}
                style={{
                    borderRadius: 16
                }}
            >

                <Row gutter={[32, 32]}>

                    {/* ================= IMAGE ================= */}

                    <Col
                        xs={24}
                        md={10}
                    >

                        <img
                            src={imageSource}

                            alt={product.product}

                            onError={fallbackToDefaultImage}

                            style={{
                                width: "100%",
                                borderRadius: 12,
                                objectFit: "cover",
                                maxHeight: 500
                            }}
                        />

                    </Col>

                    {/* ================= MAIN INFO ================= */}

                    <Col
                        xs={24}
                        md={14}
                    >

                        <Title level={2}>
                            🌾 {product.product}
                        </Title>

                        <Title level={4}>
                            Variété : {product.variety}
                        </Title>

                        <Space wrap>

                            <Tag color="blue">
                                {product.category}
                            </Tag>

                            <Tag color="green">
                                {product.subCategory}
                            </Tag>

                            <Tag color="gold">
                                Disponible
                            </Tag>

                        </Space>

                        <Divider />

                        <Descriptions
                            bordered
                            column={1}
                            size="middle"
                        >

                            <Descriptions.Item label="Prix unitaire de vente">

                                <Text strong>

                                    {product.sellingPrice}
                                    {" "}
                                    {product.currency || currency}

                                </Text>

                            </Descriptions.Item>

                            <Descriptions.Item label="Quantité unitaire de vente">

                                <Text strong>

                                    {product.sellingQuantity}
                                    {" "}
                                    {product.measurementUnit || "Kg"}

                                </Text>

                            </Descriptions.Item>

                            <Descriptions.Item label="Producteur">

                                {product.producerName}

                            </Descriptions.Item>

                            <Descriptions.Item label="Entreprise">

                                {product.companyName}

                            </Descriptions.Item>

                            <Descriptions.Item label="Région">

                                {product.region}

                            </Descriptions.Item>

                            <Descriptions.Item label="Pays">

                                {product.country}

                            </Descriptions.Item>

                        </Descriptions>

                    </Col>

                </Row>

                {/* ================= DESCRIPTION ================= */}

                {
                    product.description && (

                        <>
                            <Divider />

                            <Card
                                size="small"
                                title={
                                    <>
                                        <FileTextOutlined />
                                        {" "}
                                        Description
                                    </>
                                }
                            >

                                {product.description}

                            </Card>
                        </>
                    )
                }

                {/* ================= QUALITE ================= */}

                {
                    (
                        product.quality ||
                        product.norms ||
                        product.origin
                    ) && (

                        <>
                            <Divider />

                            <Card
                                size="small"
                                title="Caractéristiques du produit"
                            >

                                <Space wrap>

                                    {
                                        product.quality && (

                                            <Tag color="green">

                                                Qualité :
                                                {" "}
                                                {product.quality}

                                            </Tag>
                                        )
                                    }

                                    {
                                        product.norms && (

                                            <Tag color="purple">

                                                Normes :
                                                {" "}
                                                {product.norms}

                                            </Tag>
                                        )
                                    }

                                    {
                                        product.origin && (

                                            <Tag color="cyan">

                                                Origine :
                                                {" "}
                                                {product.origin}

                                            </Tag>
                                        )
                                    }

                                </Space>

                            </Card>

                        </>
                    )
                }

                {/* ================= PRODUCTEUR ================= */}

                <Divider />

                <Card
                    title="Informations du producteur"
                >

                    <Row
                        gutter={24}
                        align="middle"
                    >

                        <Col>

                            <Avatar
                                size={80}
                                icon={<UserOutlined />}
                            />

                        </Col>

                        <Col flex="auto">

                            <Title level={4}>
                                {product.producerName}
                            </Title>

                            <p>

                                <ShopOutlined />
                                {" "}
                                {product.companyName}

                            </p>

                            <p>

                                <EnvironmentOutlined />
                                {" "}
                                {product.region}
                                {" - "}
                                {product.country}

                            </p>

                            {
                                product.phone && (

                                    <p>

                                        <PhoneOutlined />
                                        {" "}
                                        {product.phone}

                                    </p>
                                )
                            }

                            {
                                product.email && (

                                    <p>

                                        <MailOutlined />
                                        {" "}
                                        {product.email}

                                    </p>
                                )
                            }

                        </Col>

                    </Row>

                </Card>

                {/* ================= LOCALISATION ================= */}

                <Divider />

                <Card
                    title="Zone de production"
                >

                    <Descriptions
                        bordered
                        column={1}
                    >

                        <Descriptions.Item label="Pays">

                            {product.country}

                        </Descriptions.Item>

                        <Descriptions.Item label="Région">

                            {product.region}

                        </Descriptions.Item>

                    </Descriptions>

                </Card>

                {/* ================= ACTIONS ================= */}

                <Divider />

                <Row
                    gutter={[16,16]}
                    justify="center"
                >

                    <Col>

                        <Button
                            type="primary"
                            size="large"
                            icon={<PhoneOutlined />}
                            // onClick={() =>
                            //     setInquiryOpen(true)
                            // }

                            onClick={handleOpenConversation}
                        >
                            💬 Envoyer une demande
                        </Button>

                    </Col>

                    <Col>

                        <Button
                            size="large"
                            onClick={() =>
                                setDeliveryOpen(true)
                            }
                        >
                            🚚 Estimer la livraison
                        </Button>

                    </Col>

                    <Col>

                        <Button
                            size="large"
                            icon={<HeartOutlined />}
                            loading={wishlistLoading}
                            onClick={handleAddToWishlist}
                        >
                            ❤️ Ajouter aux favoris
                        </Button>

                    </Col>

                </Row>

            </Card>

            <BuyerMarketplaceConversationDrawer

                open={inquiryOpen}

                onClose={() =>
                    setInquiryOpen(false)
                }

                inquiryId={inquiryId}

                product={product}
            />

            <DeliveryEstimation
                open={deliveryOpen}
                onClose={() =>
                    setDeliveryOpen(false)
                }
                product={product}
            />

        </div>
    );
};

export default ProductInstanceDetails;